/** Case studies per listing page (grid page size and initial server load). */
export const CASE_STUDIES_PAGE_SIZE = 12;